import { useMediaQuery, useTheme } from "@mui/material";

/** Returns `true` when the viewport is below the `md` breakpoint (< 900px). */
export const useIsMobile = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
};
